import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "nav-item" }
const _hoisted_2 = { class: "nav-link" }

import { SidebarPath } from "@/@types/dtos/sidebar.types";


export default /*@__PURE__*/_defineComponent({
  __name: 'SidebarPathITem',
  props: {
    path: {},
    showItem: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.showItem)
    ? (_openBlock(), _createBlock(_component_router_link, {
        key: 0,
        "active-class": "router-link-active",
        to: _ctx.path.to
      }, {
        default: _withCtx(() => [
          _createElementVNode("li", _hoisted_1, [
            _createElementVNode("a", _hoisted_2, [
              _createElementVNode("i", {
                class: _normalizeClass(`sidebar-icon icon-fix ${_ctx.path.icon}`)
              }, null, 2),
              _createTextVNode(" " + _toDisplayString(_ctx.path.name), 1)
            ])
          ])
        ]),
        _: 1
      }, 8, ["to"]))
    : _createCommentVNode("", true)
}
}

})